import { render, staticRenderFns } from "./ManageCompetitors.vue?vue&type=template&id=54b564f2&scoped=true&"
import script from "./ManageCompetitors.vue?vue&type=script&lang=js&"
export * from "./ManageCompetitors.vue?vue&type=script&lang=js&"
import style0 from "./ManageCompetitors.vue?vue&type=style&index=0&id=54b564f2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54b564f2",
  null
  
)

export default component.exports